export default function Refund() {
  return (
    <div className="min-h-screen bg-obsidian text-white font-body max-w-3xl mx-auto px-6 py-12">
      <h1 className="font-heading text-3xl font-black uppercase tracking-tight mb-2">Política de Reembolso</h1>
      <p className="text-txt-secondary text-sm mb-8">Última atualização: Maio 2026</p>

      <section className="space-y-6 text-sm text-txt-secondary leading-relaxed">
        <div>
          <h2 className="text-white font-bold text-base mb-2">1. Garantia de 14 Dias</h2>
          <p>Oferecemos uma garantia de reembolso total de 14 dias a partir da data de subscrição. Se não estiver satisfeito com o serviço Premium, pode solicitar um reembolso completo dentro deste período sem necessidade de justificação.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">2. Como Solicitar Reembolso</h2>
          <p>Para solicitar um reembolso, envie um email para <span className="text-volt">formulário de contacto no site</span> com o assunto "Reembolso" e o endereço de email da sua conta. Processamos o pedido em até 5 dias úteis.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">3. Reembolsos Após 14 Dias</h2>
          <p>Após o período de 14 dias, não são emitidos reembolsos para períodos já faturados. Pode cancelar a subscrição a qualquer momento e continuará a ter acesso Premium até ao fim do período pago.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">4. Cancelamento</h2>
          <p>Pode cancelar a sua subscrição a qualquer momento através da sua conta ou por email. O cancelamento é imediato mas o acesso Premium mantém-se até ao fim do período de faturação.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">5. Exceções</h2>
          <p>Não são elegíveis para reembolso: contas suspensas por violação dos Termos de Serviço; pedidos após 14 dias da primeira subscrição.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">6. Contacto</h2>
          <p>Para questões sobre reembolsos: <span className="text-volt">formulário de contacto no site</span></p>
        </div>
      </section>
    </div>
  );
}
